/*------------------------------------*\
    MODULES
\*------------------------------------*/


/*------------------------------------*\
    LAZYLOAD
\*------------------------------------*/
class Lazyload {
    constructor() {
        let self = this;
    }

    init() {
        let self = this;
        self.lazyImages = document.querySelectorAll('.lazy');
        self.lazyImagesBg = document.querySelectorAll('.lazy-bg');
        self.inAdvance = 300;

        // console.log('test');



        self.lazyLoad();
        self.lazyLoadBg();


        window.addEventListener('scroll', self.lazyLoad.bind(this))
        window.addEventListener('resize', self.lazyLoad.bind(this))
        window.addEventListener('scroll', self.lazyLoadBg.bind(this))
        window.addEventListener('resize', self.lazyLoadBg.bind(this))
    }

    lazyLoad() {
        let self = this;


        if (self.lazyImages) {
            self.lazyImages.forEach(image => {

                if (image.offsetTop < window.innerHeight + window.pageYOffset + self.inAdvance) {
                    if (image.src === '') {
                        image.src = image.dataset.src;
                        image.removeAttribute('data-src');
                    }
                }
            })
        }
    }

    lazyLoadBg() {
        let self = this;

        self.lazyImagesBg.forEach(image => {


            if (image.offsetTop < window.innerHeight + window.pageYOffset + self.inAdvance) {

                let dataBg = image.getAttribute('data-bg')

                if (dataBg) {
                    image.style.backgroundImage = `url('${dataBg}')`;
                    image.removeAttribute('data-bg');
                }

            }
        })
    }
}

export default Lazyload;